import { Box, Button, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { CardContainer, SubTitleCard, Text, TitleCard } from "./Styles";
import { tokens } from "../theme";

export default function Card({ children, title, subtitle, actions, sx }) {
    //call the theme
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    
    return (
        <Box sx={{ ...CardContainer(theme), ...(sx || {}) }}>
            {/* Title row with optional actions */}
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 1,
            }}>
                {title && <Typography sx={TitleCard(colors)}>{title}</Typography>}
                {actions && (
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        gap: 1,
                    }}>
                        {actions}
                    </Box>
                )}
            </Box>
            
            {/* Subtitle */}
            {subtitle && <Typography sx={SubTitleCard(colors)}>{subtitle}</Typography>}
            
            {/* Card content */}
            <Box sx={{ mt: 2, ...Text(colors) }}>
                {children}
            </Box>
        </Box>
    );
}
